import useVehiclesMutations from "../../../data/useVehiclesMutations";
import useDefaultCRUDHandlers from "../../../hooks/useDefaultCRUDHandlers";
import { IPart } from "../../../models/Part";
import classNames from "../../../utils/classNames";

export default function UnlistedPaintCodeUpdate({ part }: { part: IPart }) {
  const { update } = useVehiclesMutations();
  const { saveHandlers } = useDefaultCRUDHandlers("Paint Code");

  const savePaintCode = (value: string) => {
    if (!part.vehicle) return;

    const paintCode = value.trim();
    if ((part.vehicle.vinvisColourCode ?? "") === paintCode) return;

    const updateVehicle = {
      ...part.vehicle,
      vinvisColourCode: paintCode,
    };

    update.mutate(updateVehicle, {
      ...saveHandlers,
      onSuccess: () => {
        saveHandlers.onSuccess();
        if (part.vehicle) {
          part.vehicle.vinvisColourCode = paintCode;
        }
      },
    });
  };

  const inputClass = classNames(
    "w-full min-w-0 rounded border border-slate-200 bg-white px-1.5 py-0.5 text-xs text-black",
    "focus:border-primary-400 focus:outline-none focus:ring-1 focus:ring-primary-400"
  );

  return (
    <div
      className="flex items-center gap-1.5 text-xs text-black"
      onClick={(e) => e.stopPropagation()}
    >
      <label htmlFor={`paintCode-${part.id}`} className="flex min-w-0 flex-1 items-center gap-1.5">
        <span
          className="w-10 flex-none font-semibold uppercase tracking-wide text-black"
          title="Donor vehicle paint code"
        >
          Paint
        </span>
        <input
          id={`paintCode-${part.id}`}
          key={`${part.id}-${part.vehicle?.vinvisColourCode ?? ""}`}
          defaultValue={part.vehicle?.vinvisColourCode ?? ""}
          className={inputClass}
          type="text"
          placeholder="Add paint code"
          onBlur={(e) => savePaintCode(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              (e.target as HTMLInputElement).blur();
            }
          }}
        />
      </label>
    </div>
  );
}
